import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { list, checkupSave } from "../../requests/history";
import { createSignal, createEffect } from "solid-js";

export default function useCheckupHistory(props) {

  const [historyQuestions, setHistoryQuestions] = createSignal([]);

  const [historyForm, setHistoryForm] = createStore({
    histories: [],
  });

  // Initialize form with all history questions and existing answers
  createEffect(() => {
    if (historyQuestions().length > 0) {
      const existingHistories = props.histories || [];
      
      const formattedHistories = historyQuestions().map(question => {
        // Find existing answer for this question
        const existingHistory = existingHistories.find(h => h.historyId === question.value);
        
        // Options are already an array from backend
        const options = question.options || [];
        
        // Use existing answer if it exists in options, otherwise null
        let answer = null;
        if (existingHistory && existingHistory.originalValue) {
          if (options.includes(existingHistory.originalValue)) {
            answer = existingHistory.originalValue;
          }
        }
        
        return {
          key: existingHistory?.uid || crypto.randomUUID(),
          uid: existingHistory?.uid || null,
          historyId: question.value,
          name: question.text,
          question: question.text,
          options: options,
          answer: existingHistory?.value || null,
          originalAnswer: existingHistory?.originalValue || null, // Store original for change tracking
        };
      });
      
      setHistoryForm('histories', formattedHistories);
    }
  });

  const { successToast, errorToast } = useApplication();

  const updateHistoryAnswer = (historyKey, answer) => {
    const historyIndex = historyForm.histories.findIndex(history => history.key === historyKey);
    if (historyIndex !== -1) {
      setHistoryForm('histories', historyIndex, 'answer', answer);
    }
  }

  const clearHistoryAnswer = (historyKey) => {
    updateHistoryAnswer(historyKey, null);
  }

  const onFetchHistoryQuestions = async () => {
    try {
      const data = await list();
      setHistoryQuestions(data.list || []);
    } catch(error) {
      setHistoryQuestions([]);
    }
  }

  const onSaveHistory = async () => {
    props.setLoading(true);
    try {
      // Only save histories that have answers
      const historiesToSave = historyForm.histories.filter(history => history.answer !== null && history.answer !== '');
      
      const formData = new FormData();
      formData.append('histories', JSON.stringify(historiesToSave));

      const data = await checkupSave(formData);

      if (data.success) {
        successToast(data.message || "History saved successfully");
      } else {
        errorToast(data.message || "Failed to save history");
      }
    } catch(error) {
      errorToast("Failed to save history");
    } finally {
      props.setLoading(false);
    }
  }

  return {
    historyQuestions,
    historyForm,
    setHistoryForm,
    onSaveHistory,
    onFetchHistoryQuestions,
    updateHistoryAnswer,
    clearHistoryAnswer,
  };
}
